import * as React from "react"

export default function CryptoListItem({ imageUrl, text }) {
    return (
        <>
            <div className="image-with-text margin-top margin-small">
                <img
                    src={imageUrl}
                    alt="Blue"
                    loading="lazy"
                    className="icon"
                    width="auto"
                    height="auto" />
                <p className="crypt-func paragraph24 margin-horizontal">{text}</p>
            </div>
        </>
    )
}